/* eslint-disable no-undef */
// import 'react-intl-tel-input/dist/libphonenumber';
import isObject from 'lodash/isObject';
import { isEmpty } from "../utils/commonUtility";
import { END_DATE_REQUIRED, INVALID_EMAIL, INVALID_PHONE, INVALID_PHONE_10_DIGITS, INVALID_PHONE_NUMBER, MAX_3_DIGITS, maxLengthMessage, maxMessage, minLengthMessage, minMessage, moreThanMessage, lessThanMessage, NOT_ZERO, ONLY_ALPHA_NUMERIC, REQUIRED, START_DATE_REQUIRED } from "./validationMessages";

var isTelInput = function isTelInput(value) {
  return isObject(value) && value.isTelInput;
};

var required = function required(value) {
  return isEmpty(value) || isTelInput(value) && isEmpty(value.value) ? REQUIRED : undefined;
};

var maxLength = function maxLength(max) {
  return function (value) {
    return value && value.length > max ? maxLengthMessage(max) : undefined;
  };
};

var minLength = function minLength(min) {
  return function (value) {
    return value && value.length < min ? minLengthMessage(min) : undefined;
  };
};

var min = function min(minVal) {
  return function (value) {
    return !isEmpty(value) && value < minVal ? minMessage(minVal) : undefined;
  };
};

var max = function max(maxVal) {
  return function (value) {
    return !isEmpty(value) && value > maxVal ? maxMessage(maxVal) : undefined;
  };
};

var moreThan = function moreThan(moreThanValue) {
  return function (value) {
    return !isEmpty(value) && value <= moreThanValue ? moreThanMessage(moreThanValue) : undefined;
  };
};

var lessThan = function lessThan(lessThanValue) {
  return function (value) {
    return !isEmpty(value) && value >= lessThanValue ? lessThanMessage(lessThanValue) : undefined;
  };
};

var email = function email(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]{2,}\.[A-Z]{2,}$/i.test(value) ? INVALID_EMAIL : undefined;
};

var alphaNumeric = function alphaNumeric(value) {
  return value && /[^a-zA-Z0-9 ]/i.test(value) ? ONLY_ALPHA_NUMERIC : undefined;
};

var threeDigitsPastDecimalPoint = function threeDigitsPastDecimalPoint(value) {
  return value && !/^-?\d+(\.\d{1,3})?\s*$/i.test(value) ? MAX_3_DIGITS : undefined;
};

var notZero = function notZero(value) {
  return value && !/^(?!0$).*/i.test(value) ? NOT_ZERO : undefined;
};

var phoneNumber = function phoneNumber(value) {
  return value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? INVALID_PHONE_10_DIGITS : undefined;
};

var googlePhoneNumber = function googlePhoneNumber(value) {
  return value && !/^\+[0-9]{1,3}.[0-9,-]{4,14}(?:x.+)?$/.test(value) ? INVALID_PHONE : undefined;
};

var phone = function phone(value) {
  return value && isObject(value) && !value.isValid && !isEmpty(value.value) ? INVALID_PHONE_NUMBER : undefined;
};

var rangePickerValidation = function rangePickerValidation() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var startDate = value.startDate || value.start;
  var endDate = value.endDate || value.end;

  if (isEmpty(value) || !startDate && !endDate) {
    return REQUIRED;
  }

  if (!startDate) {
    return START_DATE_REQUIRED;
  }

  if (!endDate) {
    return END_DATE_REQUIRED;
  }

  return undefined;
};

export { notZero, required, email, phoneNumber, alphaNumeric, maxLength, minLength, min, max, moreThan, lessThan, threeDigitsPastDecimalPoint, googlePhoneNumber, rangePickerValidation, phone };